import { Component } from 'react';

class DailyPsychosocialAssessment extends Component {
  render() {
    return <h1>Daily Psychosocial Assessment</h1>;
  }
}

export default DailyPsychosocialAssessment;
